import { twoMinutesInMs } from "@ic-anywhere/ic-dal";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { getInvitationRequest } from "src/api/invitationRequests/invitationRequest.api";
import { InvitationRequestResponseDto } from "src/api/invitationRequests/invitationRequest.typings";
import useCrmRepository from "src/api/useCrmRepository";
import { userProfileStateAtom } from "src/state/userProfileAtoms";

export const useGetInvitationRequestQuery = (
  eventId: string,
  enabled: boolean
): UseQueryResult<InvitationRequestResponseDto> => {
  const repo = useCrmRepository();
  const [userState] = useAtom(userProfileStateAtom);

  return useQuery({
    queryFn: () => getInvitationRequest(repo, eventId).then(({ data }) => data),
    queryKey: ["useGetInvitationRequest", eventId, userState.userInfo.userId],
    enabled,
    gcTime: twoMinutesInMs,
  });
};
